export const dropdownChosen = (value: string | undefined) => {
    return value === undefined ? false : true;
};
